import { css } from 'styled-components';
import { TypographyName, getTypography, getSpacing, SpacingName } from '../../theme';
export const modalBodyStyle = _ref => {
  let {
    theme,
    $padded,
    $open,
    $keepMount
  } = _ref;
  return css(["", " flex-grow:1;min-height:7.5rem;overflow-y:auto;position:relative;", " ", ""], getTypography(theme, TypographyName.BODY), !$open && $keepMount && `
    display: none;
  `, $padded ? getSpacing.padding(theme, [SpacingName.SMALL, SpacingName.MEDIUM, SpacingName.MEDIUM]) : '');
};
//# sourceMappingURL=ModalBody.style.js.map